"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var WixChatSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M9,3 C12.8343621,3 16.000137,5.69125419 16.000137,9 C16.000137,9.68767845 15.8619763,10.3620142 15.5963917,10.999563 L15.537,11.129 L15.9953048,14.4316394 C16.0379403,14.7405541 15.7925017,15.0049776 15.4934712,15.0002029 L15.4107649,14.9919727 L12.069,14.385 L11.8840917,14.4634819 C11.2101582,14.7271471 10.4912774,14.8971059 9.7491173,14.9656063 L9.37619764,14.9913657 L9,15 C5.1656379,15 2,12.3087458 2,9 C2,5.69125419 5.1656379,3 9,3 Z M9,4 C5.68518282,4 3,6.28279726 3,9 C3,11.7172027 5.68518282,14 9,14 C9.99215008,14 10.949705,13.7956205 11.8086608,13.4111411 C11.8700013,13.3836844 11.9359197,13.3690161 12.0024391,13.3676187 L12.1021718,13.375536 L14.91,13.884 L14.5290208,11.1218746 C14.5155714,11.0244273 14.5311657,10.9251777 14.5738515,10.8365505 C14.8544104,10.2540356 15,9.63355152 15,9 C15,6.28279726 12.3148172,4 9,4 Z M6,8 C6.55228475,8 7,8.44771525 7,9 C7,9.55228475 6.55228475,10 6,10 C5.44771525,10 5,9.55228475 5,9 C5,8.44771525 5.44771525,8 6,8 Z M9,8 C9.55228475,8 10,8.44771525 10,9 C10,9.55228475 9.55228475,10 9,10 C8.44771525,10 8,9.55228475 8,9 C8,8.44771525 8.44771525,8 9,8 Z M12,8 C12.5522847,8 13,8.44771525 13,9 C13,9.55228475 12.5522847,10 12,10 C11.4477153,10 11,9.55228475 11,9 C11,8.44771525 11.4477153,8 12,8 Z" })));
};
WixChatSmall.displayName = 'WixChatSmall';
exports.default = WixChatSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=WixChatSmall.js.map